import { UserAvatar } from 'components/user-avatar';
import { useAuth } from 'context/AuthContext';
import { useState } from 'react';
import { AiOutlineLike, AiOutlineDislike } from 'react-icons/ai';
import { FaSync, FaCheck } from 'react-icons/fa';
import { IoCopyOutline } from 'react-icons/io5';
import iaJJImage from 'assets/img/iaPetJJ.png';

interface MessageProps {
  role: string;
  message: string;
  key: number;
  resendMessage: () => void;
}

const MessageChatIA: React.FC<MessageProps> = ({ role, message, key, resendMessage }) => {
  const { user } = useAuth();
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [isCopy, setIsCopy] = useState(false);

  const handleCopy = (msg: string) => {
    navigator.clipboard.writeText(msg);
    setIsCopy(true);
  };

  const handleLike = () => {
    setLiked(!liked);
    setDisliked(false);
  };

  const handleDislike = () => {
    setDisliked(!disliked);
    setLiked(false);
  };

  return (
    <div key={key} className={`flex ${role === 'user' ? 'justify-end' : 'justify-start'} py-2 flex-col`}>
      <div className={`${role === 'user' ? 'justify-end' : 'justify-start'} flex flex-row`}>
        {role === 'assistant' && (
          <img
            src={iaJJImage}
            alt="Imagem da Ia do Joga Junto"
            className=" bg-white text-purple w-12 h-12 flex justify-center items-center rounded-full m-2 "
          />
        )}
       {message.length > 0&& <p className={`p-4 rounded-lg ${role === 'user' ? 'rounded-br-none' : 'rounded-bl-none'} max-w-[422px] bg-prussian-blue`}>
          {message}
        </p>}
        {role === 'user' && message.length > 0 && (
          <div className=" bg-white text-purple w-12 h-12 flex justify-center items-center rounded-full m-2">
            <UserAvatar data={{ ...user, ...user?.extra }} />
          </div>
        )}
      </div>
      {role === 'assistant' && (
        <div className="flex gap-3 text-xl mt-2 ml-16">
          <button onClick={() => handleCopy(message)}>{isCopy ? <FaCheck /> : <IoCopyOutline />}</button>
          {/* <button className={`${liked ? 'text-green-500' : ''}`} onClick={handleLike}>
            <AiOutlineLike />
          </button>
          <button className={`${disliked ? 'text-red-500' : ''}`} onClick={handleDislike}>
            <AiOutlineDislike />
          </button> */}
          {message !== 'Olá! Como posso ajudar?' && (
            <button onClick={resendMessage}>
              <FaSync />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default MessageChatIA;
